import { combineReducers } from 'redux';
import list from './list.reducer';
import create from './create.reducer';
import search from './search.reducers';
import update from './update.reducer';
import quickAdd from './quickAdd.reducer';
import pending from './pending.reducer';
import description from './description.reducer';

const drugReducers = combineReducers({
  list,
  create,
  search,
  update,
  quickAdd,
  pending,
  description,
});

export default drugReducers;
